export default __webpack_public_path__ + "static/media/Vol5Issue3.9a8fc9be.png";